<template>
  <v-card id="CertificadosCard" class="Ecotrace-card">
    <v-btn
      absolute
      right
      fab
      small
      depressed
      color="white"
      class="close-btn secondary--text"
      @click="close"
    >
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-card-text class="px-8">
      <v-row class="mt-8">
        <v-col class="d-flex justify-center align-center">
          <v-img
            src="@/assets/icons/selo_sif.png"
            max-width="204"
            max-height="190"
            contain
          ></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p
            class="secondary--text text-uppercase font-weight-medium subtitle-1 mb-0 mt-2"
          >
            {{ texts.certificados_title }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p class="">
            {{ texts.certificados_text }}
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["texts"],
  methods: {
    close() {
      this.$store.state.certificados = false;
      this.$store.state.history = true;
      this.$store.state.prevNavigation = "home";
      this.$store.state.headerTitle = this.texts.historico_produto;
    }
  }
};
</script>

<style lang="scss" scoped>
#CertificadosCard {
  .close-btn {
    top: 22px;
    right: 22px;
  }
}
</style>
